
export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}


export const locations: LocationData[] = [
  {
    slug: "murfreesboro",
    name: "Murfreesboro",
    state: "TN",
    region: "Rutherford County",
    isPrimary: false,
    lat: 35.8456,
    lng: -86.3903,
    description:
      "E & J Painting is based right here in Murfreesboro, TN. Interior, exterior, residential, commercial, and drywall painting for homes and businesses across Rutherford County — free estimates, Monday through Friday.",
    highlights: [
      "Based in Smyrna, TN 37167",
      "Interior, exterior & drywall painting",
      "Free written estimates",
      "15% off the first 3 calls each month",
    ],
    content: [
      "Murfreesboro is home base for E & J Painting. We know the neighborhoods, the builders, and the way Tennessee weather treats a house — from older homes near the square to new construction out toward Blackman and Salem Creek.",
      "Homeowners here call us for whole-interior repaints, exterior siding and trim work, popcorn ceiling removal, and drywall repair that actually blends in. Commercial clients along Memorial Boulevard and Church Street trust us with offices, retail spaces, and rental turnovers scheduled around business hours.",
      "Call (615) 930-6254 for a free painting estimate in Murfreesboro today.",
    ],
    cities: [
      { name: "Blackman", lat: 35.859, lng: -86.494 },
      { name: "Smyrna", lat: 35.9828, lng: -86.5186 },
      { name: "La Vergne", lat: 36.0156, lng: -86.5819 },
      { name: "Christiana", lat: 35.71, lng: -86.397 },
    ],
  },
  {
    slug: "nashville",
    name: "Nashville",
    state: "TN",
    region: "Davidson County",
    isPrimary: false,
    lat: 36.1627,
    lng: -86.7816,
    description:
      "Professional painting contractor serving Nashville, TN. Interior and exterior repaints, commercial painting, and drywall repair across every Davidson County neighborhood.",
    highlights: [
      "Residential & commercial painting",
      "Historic and new-build homes",
      "After-hours commercial scheduling",
      "Free estimates across Davidson County",
    ],
    content: [
      "Nashville keeps us busy year-round. We paint bungalows in East Nashville, condos downtown, family homes in Bellevue and Donelson, and commercial spaces all over the city.",
      "Older Nashville homes often need more than paint — cracked plaster, settled drywall, and weathered exterior trim. We handle the repairs and the finish coat together so you're not coordinating two different crews.",
      "Get a free Nashville painting quote at (615) 930-6254.",
    ],
    cities: [
      { name: "East Nashville", lat: 36.181, lng: -86.741 },
      { name: "Bellevue", lat: 36.073, lng: -86.939 },
      { name: "Donelson", lat: 36.169, lng: -86.671 },
      { name: "Antioch", lat: 36.06, lng: -86.672 },
    ],
  },
  {
    slug: "franklin",
    name: "Franklin",
    state: "TN",
    region: "Williamson County",
    isPrimary: false,
    lat: 35.9251,
    lng: -86.8689,
    description:
      "Franklin, TN painting services. Detail-focused interior painting, exterior repaints, and cabinet refinishing for Williamson County homes and businesses.",
    highlights: [
      "Whole-home interior repaints",
      "Exterior siding, trim & soffits",
      "New construction painting",
      "Free written estimates",
    ],
    content: [
      "Franklin homeowners expect a high standard, and that's exactly the kind of work we like doing. Clean cut-in lines, properly prepped surfaces, and colors that look right in the room — not just on the swatch.",
      "We work on everything from historic homes near downtown Franklin to newer builds in Westhaven and Berry Farms, plus commercial spaces along Cool Springs.",
      "Call (615) 930-6254 to schedule your free Franklin estimate.",
    ],
    cities: [
      { name: "Cool Springs", lat: 35.938, lng: -86.816 },
      { name: "Westhaven", lat: 35.95, lng: -86.92 },
      { name: "Brentwood", lat: 36.0331, lng: -86.7828 },
    ],
  },
  {
    slug: "brentwood",
    name: "Brentwood",
    state: "TN",
    region: "Williamson County",
    isPrimary: false,
    lat: 36.0331,
    lng: -86.7828,
    description:
      "Brentwood, TN painting contractor. Interior painting, exterior repaints, trim work, and drywall repair with a clean, respectful crew.",
    highlights: [
      "Interior & exterior repainting",
      "Trim, crown molding & doors",
      "Drywall repair and texture matching",
      "Tidy, respectful job sites",
    ],
    content: [
      "Brentwood homes tend to be larger, with more trim, taller ceilings, and more detail work — which is exactly where a careful crew makes the difference.",
      "We handle two-story foyers, extensive crown molding, cabinet repaints, and full exterior projects, always with furniture covered and floors protected before we start.",
      "Reach us at (615) 930-6254 for a free Brentwood painting estimate.",
    ],
    cities: [
      { name: "Maryland Farms", lat: 36.036, lng: -86.79 },
      { name: "Nolensville", lat: 35.9526, lng: -86.6694 },
      { name: "Franklin", lat: 35.9251, lng: -86.8689 },
    ],
  },
  {
    slug: "smyrna",
    name: "Smyrna",
    state: "TN",
    region: "Rutherford County",
    isPrimary: true,
    lat: 35.9828,
    lng: -86.5186,
    description:
      "Smyrna, TN painting services. Residential and commercial painting, drywall repair, and exterior work — right here at our Smyrna home base.",
    highlights: [
      "Based in Smyrna, TN 37167",
      "Residential & commercial painting",
      "Same-week scheduling available",
      "15% off the first 3 calls each month",
    ],
    content: [
      "Smyrna is right next door, so scheduling here is easy and our response time is fast. We paint single-family homes, townhomes, rental properties, and local businesses throughout town.",
      "Interior repaints, exterior siding and trim, drywall patching, and new-construction painting are all in our regular rotation here.",
      "Book your free Smyrna estimate at (615) 930-6254.",
    ],
    cities: [
      { name: "Almaville", lat: 35.93, lng: -86.55 },
      { name: "La Vergne", lat: 36.0156, lng: -86.5819 },
      { name: "Murfreesboro", lat: 35.8456, lng: -86.3903 },
    ],
  },
  {
    slug: "la-vergne",
    name: "La Vergne",
    state: "TN",
    region: "Rutherford County",
    isPrimary: false,
    lat: 36.0156,
    lng: -86.5819,
    description:
      "La Vergne, TN painting contractor. Interior and exterior house painting, drywall repair, and commercial painting with free written estimates.",
    highlights: [
      "House & townhome painting",
      "Rental turnovers & move-outs",
      "Warehouse & commercial coatings",
      "Free written estimates",
    ],
    content: [
      "La Vergne sits right in our core service area. We handle interior repaints, exterior refreshes, and the fast rental turnovers property owners need between tenants.",
      "The industrial corridor here also keeps us busy with warehouse and commercial work scheduled outside of operating hours.",
      "Call (615) 930-6254 for a free La Vergne painting quote.",
    ],
    cities: [
      { name: "Lake Forest", lat: 36.01, lng: -86.6 },
      { name: "Smyrna", lat: 35.9828, lng: -86.5186 },
      { name: "Antioch", lat: 36.06, lng: -86.672 },
    ],
  },
  {
    slug: "nolensville",
    name: "Nolensville",
    state: "TN",
    region: "Williamson County",
    isPrimary: false,
    lat: 35.9526,
    lng: -86.6694,
    description:
      "Nolensville, TN painting services. New construction painting, interior repaints, and exterior work for one of Middle Tennessee's fastest-growing towns.",
    highlights: [
      "New construction & new-build painting",
      "Interior color changes",
      "Exterior siding & trim",
      "Free estimates",
    ],
    content: [
      "Nolensville has grown fast, and a lot of those newer homes came with builder-grade flat paint that doesn't hold up. Repainting with a quality washable finish makes a bigger difference than most homeowners expect.",
      "We also handle accent walls, trim upgrades, and full exterior projects throughout the area.",
      "Schedule your free Nolensville estimate at (615) 930-6254.",
    ],
    cities: [
      { name: "Burkitt Place", lat: 35.99, lng: -86.68 },
      { name: "Brentwood", lat: 36.0331, lng: -86.7828 },
      { name: "Triune", lat: 35.87, lng: -86.63 },
    ],
  },
  {
    slug: "mount-juliet",
    name: "Mount Juliet",
    state: "TN",
    region: "Wilson County",
    isPrimary: false,
    lat: 36.2000,
    lng: -86.5186,
    description:
      "Mount Juliet, TN painting contractor. Residential interior and exterior painting, drywall repair, and commercial projects across Wilson County.",
    highlights: [
      "Interior & exterior house painting",
      "Drywall repair & texture matching",
      "New construction painting",
      "Free written estimates",
    ],
    content: [
      "Mount Juliet's mix of established neighborhoods and new development means we do a little of everything here — refreshing older interiors, painting brand-new builds, and handling exterior repaints that hold up to full sun.",
      "Local businesses along Providence and Lebanon Road call us for after-hours commercial painting.",
      "Call (615) 930-6254 for a free Mount Juliet painting estimate.",
    ],
    cities: [
      { name: "Providence", lat: 36.196, lng: -86.51 },
      { name: "Lebanon", lat: 36.2081, lng: -86.2911 },
      { name: "Hermitage", lat: 36.187, lng: -86.6 },
    ],
  },
  {
    slug: "lebanon",
    name: "Lebanon",
    state: "TN",
    region: "Wilson County",
    isPrimary: false,
    lat: 36.2081,
    lng: -86.2911,
    description:
      "Lebanon, TN painting services. Interior painting, exterior repaints, drywall repair, and commercial painting with honest, up-front pricing.",
    highlights: [
      "Residential & commercial painting",
      "Exterior siding, trim & porches",
      "Drywall and ceiling repair",
      "Honest up-front pricing",
    ],
    content: [
      "Lebanon homeowners get the same care we give our Murfreesboro neighbors — thorough prep, quality paint, and a crew that cleans up at the end of every day.",
      "We paint farmhouses, subdivisions, downtown storefronts, and everything in between throughout Wilson County.",
      "Get your free Lebanon estimate at (615) 930-6254.",
    ],
    cities: [
      { name: "Downtown Lebanon", lat: 36.208, lng: -86.291 },
      { name: "Mount Juliet", lat: 36.2, lng: -86.5186 },
      { name: "Watertown", lat: 36.101, lng: -86.135 },
    ],
  },
  {
    slug: "hendersonville",
    name: "Hendersonville",
    state: "TN",
    region: "Sumner County",
    isPrimary: false,
    lat: 36.3048,
    lng: -86.6200,
    description:
      "Hendersonville, TN painting contractor. Interior and exterior painting for lakeside homes, subdivisions, and businesses across Sumner County.",
    highlights: [
      "Lakeside & waterfront home exteriors",
      "Interior repaints & trim work",
      "Deck, porch & railing painting",
      "Free estimates",
    ],
    content: [
      "Homes around Old Hickory Lake take a beating from sun and humidity, so exterior prep matters more here than almost anywhere else we work. We wash, scrape, prime, and caulk before a finish coat goes on.",
      "Inside, we handle full repaints, trim, ceilings, and drywall repair throughout Hendersonville.",
      "Call (615) 930-6254 for a free Hendersonville painting estimate.",
    ],
    cities: [
      { name: "Old Hickory Lake", lat: 36.29, lng: -86.62 },
      { name: "Gallatin", lat: 36.3884, lng: -86.4467 },
      { name: "Goodlettsville", lat: 36.323, lng: -86.713 },
    ],
  },
  {
    slug: "gallatin",
    name: "Gallatin",
    state: "TN",
    region: "Sumner County",
    isPrimary: false,
    lat: 36.3884,
    lng: -86.4467,
    description:
      "Gallatin, TN painting services. Residential and commercial painting, drywall repair, and full exterior projects with free written estimates.",
    highlights: [
      "Interior & exterior painting",
      "Historic home repaints",
      "Commercial & retail painting",
      "Free written estimates",
    ],
    content: [
      "Gallatin's historic homes and growing subdivisions both need painters who prep properly. Older wood siding and trim in particular need scraping and priming, not just a fresh coat over peeling paint.",
      "We serve homeowners, landlords, and business owners throughout Sumner County.",
      "Book your free Gallatin estimate at (615) 930-6254.",
    ],
    cities: [
      { name: "Downtown Gallatin", lat: 36.388, lng: -86.447 },
      { name: "Hendersonville", lat: 36.3048, lng: -86.62 },
      { name: "Castalian Springs", lat: 36.383, lng: -86.316 },
    ],
  },
  {
    slug: "spring-hill",
    name: "Spring Hill",
    state: "TN",
    region: "Williamson & Maury Counties",
    isPrimary: false,
    lat: 35.7512,
    lng: -86.9300,
    description:
      "Spring Hill, TN painting contractor. New construction painting, interior color changes, and exterior repaints throughout the Spring Hill area.",
    highlights: [
      "New construction & builder-grade repaints",
      "Interior color changes",
      "Exterior siding & trim",
      "Free estimates",
    ],
    content: [
      "Spring Hill's rapid growth means a lot of newer homes with builder-grade finishes. Upgrading to a quality washable paint is one of the cheapest improvements a homeowner here can make.",
      "We also take on full exterior projects, accent walls, and drywall repair across both the Williamson and Maury County sides of town.",
      "Call (615) 930-6254 for a free Spring Hill painting quote.",
    ],
    cities: [
      { name: "Thompson's Station", lat: 35.807, lng: -86.909 },
      { name: "Columbia", lat: 35.6151, lng: -87.0353 },
      { name: "Franklin", lat: 35.9251, lng: -86.8689 },
    ],
  },
  {
    slug: "columbia",
    name: "Columbia",
    state: "TN",
    region: "Maury County",
    isPrimary: false,
    lat: 35.6151,
    lng: -87.0353,
    description:
      "Columbia, TN painting services. Interior painting, exterior repaints, drywall repair, and commercial painting across Maury County.",
    highlights: [
      "Interior & exterior house painting",
      "Historic downtown storefronts",
      "Drywall repair & ceiling work",
      "Free written estimates",
    ],
    content: [
      "Columbia has a great mix of historic properties and new development, and we work on both. Downtown storefronts, farmhouses, and modern subdivisions all get the same thorough prep.",
      "Interior repaints, exterior work, and drywall repair are all available throughout Maury County.",
      "Get your free Columbia estimate at (615) 930-6254.",
    ],
    cities: [
      { name: "Downtown Columbia", lat: 35.615, lng: -87.035 },
      { name: "Spring Hill", lat: 35.7512, lng: -86.93 },
      { name: "Mount Pleasant", lat: 35.537, lng: -87.199 },
    ],
  },
  {
    slug: "clarksville",
    name: "Clarksville",
    state: "TN",
    region: "Montgomery County",
    isPrimary: false,
    lat: 36.5298,
    lng: -87.3595,
    description:
      "Clarksville, TN painting contractor. Residential and commercial painting, rental turnovers, and drywall repair for Montgomery County.",
    highlights: [
      "Residential & commercial painting",
      "Rental & military-move turnovers",
      "Interior and exterior projects",
      "Free estimates",
    ],
    content: [
      "Clarksville's steady turnover of homes near Fort Campbell means fast, reliable repaints matter. We handle move-out and move-in painting on a schedule that works for landlords and families relocating.",
      "Full interior repaints, exterior siding and trim, and drywall repair are all available throughout Montgomery County.",
      "Call (615) 930-6254 for a free Clarksville painting estimate.",
    ],
    cities: [
      { name: "Sango", lat: 36.503, lng: -87.257 },
      { name: "St. Bethlehem", lat: 36.578, lng: -87.29 },
      { name: "Woodlawn", lat: 36.508, lng: -87.516 },
    ],
  },
  {
    slug: "dickson",
    name: "Dickson",
    state: "TN",
    region: "Dickson County",
    isPrimary: false,
    lat: 36.0770,
    lng: -87.3878,
    description:
      "Dickson, TN painting services. Interior and exterior house painting, drywall repair, and commercial work with honest, up-front pricing.",
    highlights: [
      "Interior & exterior painting",
      "Farmhouse & rural property exteriors",
      "Drywall repair & texture matching",
      "Free written estimates",
    ],
    content: [
      "Dickson sits at the western edge of our service area and we're glad to make the drive. Farmhouses, rural properties, and in-town homes all get the same thorough prep and quality coatings.",
      "Exterior repaints, interior color changes, and drywall repair are all available throughout Dickson County.",
      "Book your free Dickson estimate at (615) 930-6254.",
    ],
    cities: [
      { name: "Downtown Dickson", lat: 36.077, lng: -87.388 },
      { name: "White Bluff", lat: 36.106, lng: -87.221 },
      { name: "Burns", lat: 36.056, lng: -87.31 },
    ],
  },
];

export const primaryLocation = locations.find((l) => l.isPrimary) ?? locations[0];
